import { ArticleType, DocumentType } from '@innedit/innedit-type';
import { Link } from 'gatsby';
import React, { FC, SyntheticEvent } from 'react';
import type { SearchResponseHit } from 'typesense/lib/Typesense/Documents';

import Button from '../../components/Button';

const DataIdentificationArticle: FC<{
  espaceId: string;
  hit: SearchResponseHit<DocumentType<ArticleType>>;
  onClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
}> = ({ espaceId, hit, onClick }) => (
  <div className="flex items-center justify-between">
    <Link to={`/espaces/${espaceId}/articles/${hit.document.id}/update`}>
      {hit.document.label}
    </Link>
    <Button
      color="neutral"
      datas={{
        'data-collection': 'articles',
        'data-id': hit.document.id,
        'data-label': hit.document.label,
      }}
      onClick={onClick}
      size="xs"
      variant="ghost"
    >
      Associer
    </Button>
  </div>
);

export default DataIdentificationArticle;
